import { Header } from "../components/Header";
import { Wind, Twitter, Mail } from "lucide-react";

const About = () => {
  return (
    <div className="min-h-screen bg-[#F5E6D3]">
      <Header />
      <main className="container mx-auto px-4 py-8">
        <div className="max-w-2xl mx-auto">
          <h1 className="text-3xl font-bold mb-8 text-[#2C1810]">About Me</h1>
          <div className="prose prose-stone">
            <p className="text-[#1A0F0A] leading-relaxed mb-6">
              Hello! I am a writer based in London, currently my attention is on novels and short stories, but I take commissions so please don't hesitate to contact me. If you would like to feature my work in anything, please also shoot me a message on BlueSky, X, or by Email below!
            </p>
            <p className="text-[#1A0F0A] leading-relaxed mb-6">
              I have been writing since the age of around 15, where I began with poetry and plays. At University, I was lucky enough to have two of my plays performed and was the President of the playwrighting society there in my third year.
            </p>
            <p className="text-[#1A0F0A] leading-relaxed">
              I have a deep fascination with fantasy, sci-fi and quirky genres - in particular I have recently enjoyed the works of both Jorge Luis Borges and Ted Chiang.
            </p>
            
            <h2 className="text-2xl font-semibold mt-8 mb-4 text-[#2C1810]">Contact Me</h2>
            <div className="flex gap-6 items-center">
              <a
                href="https://bsky.app/profile/edramsey.bsky.social"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#1A0F0A] hover:text-[#B85B3D] transition-colors"
                aria-label="Bluesky Profile"
              >
                <Wind className="w-10 h-10" />
              </a>
              <a
                href="https://x.com/Edward__Ramsey"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#1A0F0A] hover:text-[#B85B3D] transition-colors"
                aria-label="X (Twitter) Profile"
              >
                <Twitter className="w-10 h-10" />
              </a>
              <a
                href="mailto:edramsey496@gmail.com"
                className="text-[#1A0F0A] hover:text-[#B85B3D] transition-colors"
                aria-label="Email"
              >
                <Mail className="w-10 h-10" />
              </a>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default About;